import axios from 'axios';

import {
  encrypData,
  getEncryptedKey,
  decrypData,
  randomKey as makeRandomKey,
} from '@helpers/security';
import { getEnv } from '@config';
import { store } from '@store/store';

import { deleteLoginValues } from '@store/login/actions';
import { routerActions } from 'connected-react-router';

let instance;

const { encrypted: encryption, bffURL, country, timeout } = getEnv();

export const axiosInstance = {
  getInstance: () => {
    if (!instance) {
      instance = axios.create({
        baseURL: bffURL,
        timeout,
      });
    }
    return instance;
  },
};

export const defaultHeaders = {
  'x-flow-country': country,
  'Content-Type': 'application/json',
};

export const getFullHeader = () => {
  const { access_token: accessToken } = store.getState().login.jwt;
  return { ...defaultHeaders, Authorization: `Bearer ${accessToken}` };
};

const hasAuthorization = (config) =>
  // eslint-disable-next-line no-prototype-builtins
  !(config.hasOwnProperty('hasAuthorization') && !config.hasAuthorization);

const requestHandler = (request) => {
  if (hasAuthorization(request)) {
    request.headers = { ...request.headers, ...getFullHeader() };
  } else {
    request.headers = { ...defaultHeaders, ...request.headers };
  }
  if (encryption && request.method !== 'patch') {
    const randomKey = makeRandomKey();
    const { payload, key } = encrypData(request, randomKey);
    if (payload !== '') {
      request.data = { payload };
    } else {
      request.data = {};
    }
    request.headers['x-flow-tkn'] = getEncryptedKey(key);
    request.headers['x-flow-type-key'] = randomKey;
  }
  return request;
};

// eslint-disable-next-line prefer-promise-reject-errors
const errorHandler = (error) => {
  if (error.response && error.response.status === 401) {
    const isExpired = true;
    store.dispatch(deleteLoginValues(isExpired));
    store.dispatch(routerActions.push('/login'));
  }
  return Promise.reject({
    ...error.response?.data,
    status: error?.response?.status,
  });
};

const successHandler = (response) => {
  if (encryption && response.config.method !== 'patch') {
    const key = response.config.headers['x-flow-type-key'];
    return JSON.parse(decrypData(response.data.payload, key));
  }
  if (!response.data.payload && response.data) {
    response.data.payload = response.data;
  }
  return response.data.payload;
};

// Add interceptors
axiosInstance.getInstance().interceptors.request.use((request) => requestHandler(request));

axiosInstance.getInstance().interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);
